import { render, staticRenderFns } from "./EditTrainingExpenses.vue?vue&type=template&id=4fc36808&scoped=true"
import script from "./EditTrainingExpenses.vue?vue&type=script&lang=js"
export * from "./EditTrainingExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc36808",
  null
  
)

export default component.exports